<div class="row position-relative">
  <div class="col position-relative resume-on-newtab">
    <pdf-viewer
    [src]="previewresumeurl" *ngIf="previewresumeurl"
    [render-text]="true"
    [original-size]="true"
    frameborder="0"
    type="application/pdf"
    allowfullscreen
    class="doc-iframe-div">
  </pdf-viewer>
  </div>
</div>
